/**
 * List-page state in the URL for web-billing (OPEN-191 / OPEN-204): web-shared's helpers bound to
 * this app's router. A list row opens its detail with `listFrom(location)` as router state, and
 * the detail's Back goes to `useBackTo(<list path>)`. See web-shared `lib/url-state.ts`.
 */

import { useLocation, useSearchParams } from 'react-router-dom';
import { createUrlState } from '@lodex-pro/web-shared';

export {
  ariaSort,
  listFrom,
  sortRows,
  type ListFromState,
  type SortState,
} from '@lodex-pro/web-shared';

export const { useUrlParam, useUrlFlag, useUrlNumber, useBackTo, useUrlSort } = createUrlState({
  useSearchParams,
  useLocation,
});
